module.exports = __webpack_public_path__ + "media/images/illustrations/prepworks-services-ca486cd7d729e4574385b9855a30bfd8.svg";